import VaspUserEmailConfirmation from './VaspUserEmailConfirmation'

export default VaspUserEmailConfirmation
